import { render, staticRenderFns } from "./JumpingJackBanner.vue?vue&type=template&id=bc470f36&scoped=true&"
import script from "./JumpingJackBanner.vue?vue&type=script&lang=js&"
export * from "./JumpingJackBanner.vue?vue&type=script&lang=js&"
import style0 from "./JumpingJackBanner.vue?vue&type=style&index=0&id=bc470f36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc470f36",
  null
  
)

export default component.exports